import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { Header } from "@/components/Header";
import StartPage from "@/pages/StartPage";
import ChecklistPage from "@/pages/ChecklistPage";
import HistoryPage from "@/pages/HistoryPage";
import SettingsPage from "@/pages/SettingsPage";

function App() {
  return (
    <div className="min-h-screen bg-[#FBF9F5]">
      <BrowserRouter>
        <Header />
        <main className="max-w-6xl mx-auto px-4 sm:px-6 py-8 sm:py-12">
          <Routes>
            <Route path="/" element={<StartPage />} />
            <Route path="/checklist/:id" element={<ChecklistPage />} />
            <Route path="/history" element={<HistoryPage />} />
            <Route path="/settings" element={<SettingsPage />} />
          </Routes>
        </main>
        <footer className="border-t border-[#E2DAD0] py-6 text-center" data-testid="footer">
          <span className="text-xs uppercase tracking-[0.2em] text-[#9A9188]">Developed by Putera</span>
        </footer>
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
